<template>
  <div id="page-product-form">
    <vs-row>
      <vs-col>
        <card-page :card-title="cardTitle">
          <vue-element-loading :active="busy"></vue-element-loading>
          <vue-form-generator
              class="mt-4"
              ref="form"
              :model="model"
              :options="formOptions"
              :schema="schema"
          />
        </card-page>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>

import FormModelMixin from '@/components/mixins/FormModelMixin';
import FormFieldValidationMixin from "@/components/mixins/FormFieldValidationMixin";
import {selectOptions, datepickerOptions} from '@/components/form/FormElementOption';
import moment from 'moment';
import CardPage from '../../../../components/Views/CardPage';

export default {
  name: 'SectionForm',
  props: {
    value: {
      type: Object,
      required: true
    },
    cardTitle: {
      type: String,
      required: false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  components: {
    CardPage
  },
  mixins: [FormModelMixin, FormFieldValidationMixin],
  data() {
    return {
      selectedReferences: [],
      model: {
        LloydsRiskCode_FK: null,
        OriginalSigningNumberDate: null,
        UCR: null,
      },
      formReferences: [
        'form',
      ],
      schema: {
        groups: [
          {
            styleClasses: 'w-full',
            fields: [
              {
                type: 'vueMultiSelect',
                inputType: 'text',
                styleClasses: 'w-1/3',
                label: 'Risk Code',
                model: 'LloydsRiskCode_FK',
                values: () => this.riskCodes,
                selectOptions,
                required: true,
                validator: ['required'],
              },
              {
                type: 'input',
                inputType: 'text',
                styleClasses: 'w-1/3',
                label: 'OSND',
                model: 'OriginalSigningNumberDate',
              },
              {
                type: 'input',
                inputType: 'text',
                styleClasses: 'w-1/3',
                label: 'UCR',
                model: 'UCR',
              },
            ]
          },
        ],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
      riskCodes: [],
      options: [
        {
          endpoint: () => this.$api.productLloydsRiskCode.list(),
          optionsFieldName: 'riskCodes',
          nameFieldName: 'LloydsRiskCode',
          idFieldName: 'LloydsRiskCode_FK',
          modelArrayName: 'risk_codes',
        },
      ],
    };
  },
};
</script>
